import { render, staticRenderFns } from "./SingleCV.vue?vue&type=template&id=c8cedde0&scoped=true"
import script from "./SingleCV.vue?vue&type=script&lang=js"
export * from "./SingleCV.vue?vue&type=script&lang=js"
import style0 from "./SingleCV.vue?vue&type=style&index=0&id=c8cedde0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cedde0",
  null
  
)

export default component.exports